import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';

@Injectable()
  export class MenuService {
    private menuData: any = false;
  
    private allModules = [
      'tracker',
      'frs',
      'scmgit',
      'scmsvn',
      'scmcvs',
      'build',
      'wiki',
      'docman',
      'forum',
    ];
  
    private moduleItemsMap = {
      forum: 'forums',
      docman: 'docmanfolders',
      frs: 'packages',
      tracker: 'trackers',
    };
  
    constructor(private http: HttpClient) {}
  
    getDataFromAPIResponse(response: any): any {
      if (_.get(response, 'succeeded', false)) {
        const data = _.get(response, 'data', false);
        if (_.get(data, 'projectMenu', false)) {
          // Strip the values out of JS map, create a basic array instead
          _.set(
            data,
            'projectMenu.trackers',
            _.values(_.get(data, 'projectMenu.trackers', {}))
          );
        }
        return data;
      }
      return false;
    }
  
    setMenuData(data: any): void {
      this.menuData = data;
    }
  
    getMenuData(): any {
      return this.menuData;
    }
  
    getMegaMenuForProject(unixName: string): Promise<any> {
      const url = `/site/mega/${unixName}?po=1`;
      return this.http
        .get(url)
        .toPromise()
        .then((response) => this.getDataFromAPIResponse(response))
        .catch((error) => {
          throw error;
        });
    }
  
    getProjectMenu(unixName: string): Promise<any> {
      return this.getMegaMenuForProject(unixName).then((mega) =>
        _.get(mega, 'projectMenu', false)
      );
    }
  
    moduleAvailable(pm: any, moduleName: string): boolean {
      if (!_.get(pm, moduleName, false)) {
        return false;
      }
      if (!_.includes(_.get(pm, 'modules', []), moduleName)) {
        return false;
      }
      return true;
    }
  
    shouldShowModule(pm: any, moduleName: string): boolean {
      if (!this.moduleAvailable(pm, moduleName)) return false;
      if (this.isProjectAdmin(pm)) return true;
      return this.anyModuleItemsAvailable(pm, moduleName);
    }
  
    isProjectAdmin(pm: any): boolean {
      return _.get(pm, 'admin', false);
    }
  
    anyModuleItemsAvailable(pm: any, moduleName: string): boolean {
      if (!this.moduleAvailable(pm, moduleName)) return false;
      const total = _.reduce(
        _.get(pm, this.moduleItemsMap[moduleName], [1]),
        _.add,
        0
      );
      return total > 0;
    }
  
    anyTrackersAvailable(pm: any): boolean {
      if (!this.moduleAvailable(pm, 'tracker')) return false;
      return _.filter(_.get(pm, this.moduleItemsMap.tracker), 'canRead').length > 0;
    }
  
    isProjectMember(pm: any): boolean {
      if (this.isProjectAdmin(pm)) return true;
      const modules = _.get(pm, 'modules', []);
      const total = _.reduce(
        _.map(modules, (mod) => _.get(pm, mod, 0)),
        _.add
      );
      return total > 0;
    }
  
    getAllAvailable(pm: any): any {
      var ret: any = this.allModules.reduce((carry, moduleName) => {
          carry[moduleName] = this.anyModuleItemsAvailable(pm, moduleName);
          return carry;
      }, {});
      ret.tracker = this.anyTrackersAvailable(pm);

      return ret;
    }
  
    getMenuGlyph(pm: any, state: any): string {
      if (state.includes('home.project.summary.scm')) {
        if (this.moduleAvailable(pm, 'scmcvs')) {
          return 'glyph-img-cvs';
        }
        if (this.moduleAvailable(pm, 'scmsvn')) {
          return 'glyph-img-svn';
        }
        if (this.moduleAvailable(pm, 'scmgit')) {
          return 'glyph-img-git';
        }
        return 'glyph-img-project-2';
      }
  
      if (state.includes('home.project.summary.standup')) {
        return 'glyph-img-standup';
      }
  
      if (state.includes('home.project.summary.sprints')) {
        return 'glyph-img-sprint';
      }
  
      if (state.includes('home.project.summary.sprint')) {
        return 'glyph-img-sprint';
      }
  
      if (state.includes('home.project.summary.frs')) {
        return 'glyph-img-release';
      }
  
      if (state.includes('home.project.summary.builds')) {
        return 'glyph-img-cicd';
      }
  
      if (state.includes('home.project.summary.wiki')) {
        return 'glyph-img-wiki';
      }
  
      if (state.includes('home.project.summary.docman')) {
        return 'glyph-img-document';
      }
  
      if (state.includes('home.project.summary.forum')) {
        return 'glyph-img-chat';
      }
  
      if (state.includes('home.project.summary.tracker') || state.includes('home.project.summary.query')) {
        return 'glyph-img-ticket';
      }
  
      if (state.includes('home.project.summary.admin')) {
        return 'glyph-img-setting';
      }
  
      if (state.includes('home.project.summary.reports')) {
        return 'glyph-img-report';
      }
  
      if (state.includes('home.project.summary.team')) {
        return 'glyph-img-team';
      }

      if (state.includes('home.project.summary.flow')) {
        return 'glyph-img-gforge-flow';
      }

      return 'glyph-img-project';
    }
  }
  